document.addEventListener('DOMContentLoaded', () => {
            
            // --- Configuration ---
            // PARALLAX_FACTOR: Controls the speed. 0.2 means 20% of the vertical scroll distance is applied horizontally.
            const PARALLAX_FACTOR = 0.2; 
            // MAX_OFFSET: The initial displacement (e.g., how far off-screen the element starts).
            const MAX_OFFSET = 300; 

            // --- Element Selection ---
            const rightToLeftElements = document.querySelectorAll('.scroll-item-right-to-left');
            const leftToRightElements = document.querySelectorAll('.scroll-item-left-to-righ');

            /**
             * Calculates and applies the horizontal transform based on the global scroll position.
             * @param {HTMLElement} element - The DOM element to move.
             * @param {number} directionFactor - Use 1 for initial positive offset (starts right); Use -1 for initial negative offset (starts left).
             * @param {number} maxOffset - The maximum shift distance (initial offset).
             */
            function applyParallax(element, directionFactor, maxOffset) {
                let movement = 0;
                
                // 1. Initial Offset: Sets the starting position (e.g., +300px or -300px).
                const initialOffset = maxOffset * directionFactor; 

                // 2. Scroll-Based Movement: Directly linked to the vertical scroll position (window.scrollY).
                // The negative sign ensures the movement is opposite the scroll direction (parallax effect).
                const scrollBasedMovement = -window.scrollY * PARALLAX_FACTOR * directionFactor;

                // The final translation is the initial offset plus the continuous scroll adjustment.
                movement = initialOffset + scrollBasedMovement;
                
                // Apply the transform
                element.style.transform = `translateX(${movement}px)`;
            }


            /**
             * The main function called on every scroll event.
             */
            function handleScroll() {
                // Right-to-Left: directionFactor=1 (Starts Right, negative scroll movement pulls it left)
                rightToLeftElements.forEach(el => {
                    applyParallax(el, 3, MAX_OFFSET);
                });

                // Left-to-Right: directionFactor=-1 (Starts Left, negative scroll movement * (-1) makes it positive, pulling it right)
                leftToRightElements.forEach(el => {
                    applyParallax(el, -3, MAX_OFFSET);
                });
            }

            // Initial call to set the position on load
            handleScroll();

            // Attach the scroll listener
            window.addEventListener('scroll', handleScroll);
            window.addEventListener('resize', handleScroll);
        });